import React from 'react';
import { Link } from 'react-router-dom';

const Ecommerce = () => {
    return (
        <div>
            <div>
  <div className="breadcrumb-banner-area" style={{backgroundImage: 'url(./img/service-header.png)'}}>
    <div className="container">
      <div className="row mb-5">
        <div className="col-md-12">
          <div className="breadcrumb-text text-center">
            <p>Our Services</p>
            <h2>e-Commerce Development 
              &amp; Website Designing</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <br />
  {/* breadcrumb-banner-area-end */}
  <div className="container">
    <div className="row mb-5">
      <div className="col-sm-12 col-lg-5">
        <img src="./img/image-ecommerce.png" className="img-fluid img-ecommerce" />
      </div>
      <div className="col-sm-12 col-lg-7">
        <div>
          <p>The web is flooding with eCommerce websites, but only the best ones create a difference.</p>
          <p>At Techarabiya, we build innovative e-commerce platform dedicated to your needs or modify existing solutions to help scale up your business. Cross-platform sales automation is one of our specialization. We build large scale systems based on Amazon, eBay, Rakuten marketplaces and platforms such as Magneto or Shopify.</p>
          <p>Inventory management, stocks synchronization, international trading, shipping management, 
            buyer-seller communication platforms those are just a few of areas that we could automate for you.
          </p>
          <p>Our services also includes Web Design, Web Development and Digital Marketing Services. We provide end-to-end solutions from design to development to maintenance and support. Our SEO Experts will help you spread your reach to a wider audience and improve goal conversions… it’s all under one 
            umbrella. 
          </p>
          <h5>With our eCommerce websites, shopping becomes better.  
          </h5>
        </div>
      </div>
    </div>
  </div>
  <div className="container-fluid aboutus">
    <div className="container">
      <div className="row mb-5">
        <div id="ecommerce" className="col-sm-12 col-lg-6 align-self-center">
          <div className="style-ecommerce">
            <h2><b>Services We Offer</b></h2>
            <hr />
            <ul className="list-check list-unstyled list">
              <li><i className="far fa-check-circle" />Custom eCommerce Web Development
              </li>
              <li> <i className="far fa-check-circle" />eCommerce Shopping Cart Development</li>
              <li><i className="far fa-check-circle" />Payment Gateway Integration</li>
              <li><i className="far fa-check-circle" />eCommerce Website Design &amp; Customization</li>
              <li><i className="far fa-check-circle" />eCommerce Website Design &amp; Customization</li>
              <li> <i className="far fa-check-circle" />Responsive eCommerce Websites</li>
              <li> <i className="far fa-check-circle" />Maintenance and Support</li>
            </ul>
          </div>
        </div>
        <div className="col-sm-12 col-lg-6">
          <img src="./img/ecommerce.png" className="img-fluid img-ecommerce" />
        </div>
      </div>
    </div>
    <div className="container contactus">
  <div className="row mb-5">
    <div className="col-lg-8 col-sm-12 align-self-center">
		<div className="d-flex justify-content-center">
		<span className="contact-text">Are you ready to work with us? Get in touch now!</span>
		</div>
        
     
    </div>
    <div className="col-lg-4 col-sm-12 align-self-center">
      <div className="d-flex justify-content-center">
		 <Link to="/ContactUs" className="contact-button"> CONTACT US NOW </Link>
      </div>
    </div>
  </div>
</div>
  </div>
</div>

        </div>
    )
}

export default Ecommerce
